export var CompanyIdentifier;
(function (CompanyIdentifier) {
    CompanyIdentifier["IdentifierVat"] = "identifierVat";
    CompanyIdentifier["IdentifierNationalRegistration"] = "identifierNationalRegistration";
    CompanyIdentifier["IdentifierSiren"] = "identifierSiren";
    CompanyIdentifier["IdentifierCreditreform"] = "identifierCreditreform";
    CompanyIdentifier["IdentifierFiscalCode"] = "identifierFiscalCode";
    CompanyIdentifier["IdentifierTeikoku"] = "identifierTeikoku";
    CompanyIdentifier["IdentifierDuns"] = "identifierDuns";
    CompanyIdentifier["IdentifierLei"] = "identifierLei";
    CompanyIdentifier["IdentifierNifEs"] = "identifierNifEs";
    CompanyIdentifier["IdentifierFiscalCodeIt"] = "identifierFiscalCodeIt";
    CompanyIdentifier["IdentifierCciaaIt"] = "identifierCciaaIt";
    CompanyIdentifier["IdentifierCompanyNumberGb"] = "identifierCompanyNumberGb";
    CompanyIdentifier["IdentifierChamberOfCommerce"] = "identifierChamberOfCommerce";
    CompanyIdentifier["IdentifierBce"] = "identifierBce";
    CompanyIdentifier["IdentifierKvk"] = "identifierKvk";
    CompanyIdentifier["IdentifierFirmenbuchAt"] = "identifierFirmenbuchAt";
    CompanyIdentifier["IdentifierNifPt"] = "identifierNifPt";
    CompanyIdentifier["IdentifierKrs"] = "identifierKrs";
    CompanyIdentifier["IdentifierRegon"] = "identifierRegon";
    CompanyIdentifier["IdentifierIco"] = "identifierIco";
    CompanyIdentifier["IdentifierRcsLu"] = "identifierRcsLu";
    CompanyIdentifier["IdentifierAbn"] = "identifierAbn";
    CompanyIdentifier["IdentifierAcn"] = "identifierAcn";
    CompanyIdentifier["IdentifierCnpj"] = "identifierCnpj";
    CompanyIdentifier["IdentifierUscc"] = "identifierUscc";
    CompanyIdentifier["IdentifierCorporateJp"] = "identifierCorporateJp";
    CompanyIdentifier["IdentifierRfc"] = "identifierRfc";
    CompanyIdentifier["IdentifierCuit"] = "identifierCuit";
    CompanyIdentifier["IdentifierNitCo"] = "identifierNitCo";
    CompanyIdentifier["IdentifierIceMa"] = "identifierIceMa";
    CompanyIdentifier["IdentifierGstin"] = "identifierGstin";
})(CompanyIdentifier || (CompanyIdentifier = {}));
